import { render, staticRenderFns } from "./TitleH2.vue?vue&type=template&id=f292c682&"
import script from "./TitleH2.vue?vue&type=script&lang=ts&"
export * from "./TitleH2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports